<script>
import CommonConstants from '../../common/Constants';
import Utils from '../../common/Utils';


export default {
    components: {
    },
    created(){
        if (localStorage.getItem('colorScheme') === 'dark') {
            this.darkTheme = true;
        }
    },
    mounted(){
        const dailyPlanReport = localStorage.getItem('dailyPlanReport');
        if (dailyPlanReport) {
            const data = JSON.parse(dailyPlanReport);
            this.fiscalOperations = data.fiscalOperation;
            this.opsSpzTrvs = data.opsSpzTrvs;
            this.opsCVT = data.opsCVT;
            this.issueDate = data.issueDate;
            this.issueTime = data.issueTime;
            this.plantOperation = data.plantOperation;

            const scheduledOperationFields = [ 'title',  'voyageNumber',  't',  'vessel',  'productCode',  'minQuantity',  'maxQuantity',  'oleodotti',  'tanks',  'aspirazioni',  'pumps',  'mis',  'inspector',  'mooring',  'note' ];
    
            const result = [];
            for (const key in data.scheduledOperations) {
                const { items, platformName } = data.scheduledOperations[key];
                if (items && items.length) {
                    items.forEach(item => {
                        const newObj = { ...scheduledOperationFields.reduce((acc, curr) => ({ ...acc, [curr]: null }), {}), platformName, ...item };
                        result.push(newObj);
                    });
                } else {
                    const newObj = { ...scheduledOperationFields.reduce((acc, curr) => ({ ...acc, [curr]: null }), {}), platformName, ...data.scheduledOperations[key] };
                    result.push(newObj);
                }
            }

            this.scheduledOperations = result;
        }

    },
    data(){
        return{
            issueDate: null,
            issueTime: null,
            fiscalOperations: [],
            opsCVT: [],
            opsSpzTrvs: [],
            plantOperation: [],
            scheduledOperations: [],
            darkTheme: false,
        }
    },
    computed: {
        constants(){
            return CommonConstants;
        },
        utils(){
            return Utils;
        },
        uiPermissions(){
            return this.$store.getters['security/uiPermissions'];
        },
    },
    methods: {
    }
}
</script>

<template>
    <main>
        <h4>{{$t('operativePlan.emittedOn') + issueDate}} {{$t('operativePlan.at') + issueTime}}</h4>
        <div class="grid">
            <div class="col-4">
                <DataTable :value="fiscalOperations" showGridlines stripedRows class="mt-4 p-datatable-sm"
                :rowClass="rowData => (rowData.operationStatus === 'CC') ? 'red-row' : 'yellow-row'"
                scrollable scrollHeight="60vh" :class="darkTheme ? 'dark' : 'light'" >
                    <Column field="tanks" :header="$t('operativePlan.tank')"></Column>
                    <Column field="operationCode" :header="$t('operativePlan.operationCode')"></Column>
                    <Column field="product" :header="$t('product.fk')"></Column>
                    <Column field="operationDateTime" :header="$t('operativePlan.operationDateTime')"></Column>
                    <Column field="operationClass" :header="$t('operativePlan.operationClass')"></Column>
                    <Column field="note" :header="$t('operativePlan.notes')"></Column>
                </DataTable>
            </div>
            <div class="col-8">
                <div class="grid">
                    <div class="col-12">
                        <DataTable :value="plantOperation" showGridlines stripedRows class="mt-4 p-datatable-sm"
                        :rowClass="rowData => (rowData.operationStatus === 'CC') ? 'red-row' : 'yellow-row'"
                        :class="darkTheme ? 'dark' : 'light'" >
                            <Column field="operation" :header="$t('operativePlan.operation')"></Column>
                            <Column field="product" :header="$t('product.fk')"></Column>
                            <Column field="tanks" :header="$t('operativePlan.tanks')"></Column>
                            <Column field="qty" :header="$t('operativePlan.qty')"></Column>
                            <Column field="operationDateTime" :header="$t('operativePlan.operationDateTime')"></Column>
                            <Column field="note" :header="$t('operativePlan.notes')"></Column>
                        </DataTable>
                    </div>
                    <div class="col-12">
                        <DataTable :value="scheduledOperations" showGridlines stripedRows groupRowsBy="platformName" rowGroupMode="rowspan" class="mt-4 p-datatable-sm scrollable"
                        :rowClass="rowData => (rowData.operationStatus === 'CC') ? 'red-row' : ((rowData.operationStatus && (rowData.operationStatus !== 'CA')) ? 'yellow-row' : '')"
                        :class="darkTheme ? 'dark' : 'light'" >
                            <Column field="platformName" :header="$t('operativePlan.ptf')"></Column>
                            <Column field="voyageNumber" :header="$t('operativePlan.voyageNumber')"></Column>
                            <Column field="t" :header="$t('operativePlan.t')"></Column>
                            <Column field="vessel" :header="$t('vessel.fk')"></Column>
                            <Column field="productCode" :header="$t('product.fk')"></Column>
                            <Column field="minQuantity" :header="$t('operativePlan.minQuantity')"></Column>
                            <Column field="maxQuantity" :header="$t('operativePlan.maxQuantity')"></Column>
                            <Column field="oleodotti" :header="$t('operativePlan.pipeline')"></Column>
                            <Column field="tanks" :header="$t('operativePlan.tanks')"></Column>
                            <Column field="aspirazioni" :header="$t('operativePlan.aspirators')"></Column>
                            <Column field="pumps" :header="$t('operativePlan.pumps')"></Column>
                            <Column field="mis" :header="$t('operativePlan.mis')"></Column>
                            <Column field="inspector" :header="$t('inspector.fk')"></Column>
                            <Column field="mooring" :header="$t('operativePlan.mooring')"></Column>
                            <Column field="note" :header="$t('operativePlan.notes')"></Column>
                        </DataTable>
                    </div>
                </div>
            </div>
            <div class="col-8">
                <h3>{{$t('operativePlan.displacementTransfer')}}</h3>
                <DataTable :value="opsSpzTrvs" showGridlines stripedRows class="mt-4 p-datatable-sm"
                :rowClass="rowData => (rowData.operationStatus === 'CC') ? 'red-row' : 'yellow-row'"
                :class="darkTheme ? 'dark' : 'light'">
                    <Column field="operation" :header="$t('operativePlan.operation')"></Column>
                    <Column field="firstPipeline" :header="$t('operativePlan.pipeline')"></Column>
                    <Column field="firstAspirator" :header="$t('operativePlan.shortAspirator')"></Column>
                    <Column field="firstTank" :header="$t('operativePlan.tank')"></Column>
                    <Column field="firstPump" :header="$t('operativePlan.firstPump')"></Column>
                    <Column field="productCode" :header="$t('operativePlan.code')"></Column>
                    <Column field="productDesc" :header="$t('product.fk')"></Column>
                    <Column field="qty" :header="$t('operativePlan.qty')"></Column>
                    <Column field="operationDateTime" :header="$t('operativePlan.operationDateTime')"></Column>
                    <Column field="otherTanks" :header="$t('operativePlan.tank')"></Column>
                    <Column field="otherPipelines" :header="$t('operativePlan.pipeline')"></Column>
                    <Column field="otherAspirators" :header="$t('operativePlan.shortAspirator')"></Column>
                    <Column field="platform" :header="$t('operativePlan.platform')"></Column>
                    <Column field="note" :header="$t('operativePlan.notes')"></Column>
                </DataTable>
            </div>
            <div class="col-4">
                <h3>{{$t('operativePlan.cvt')}}</h3>
                <DataTable :value="opsCVT" showGridlines stripedRows class="mt-4 p-datatable-sm"
                :rowClass="rowData => (rowData.operationStatus === 'CC') ? 'red-row' : 'yellow-row'"
                :class="darkTheme ? 'dark' : 'light'">
                    <Column field="atb" :header="$t('operativePlan.atb')"></Column>
                    <Column field="atk" :header="$t('operativePlan.atk')"></Column>
                    <Column field="tanks" :header="$t('operativePlan.tanks')"></Column>
                    <Column field="product" :header="$t('product.fk')"></Column>
                    <Column field="qty" :header="$t('operativePlan.qty')"></Column>
                    <Column field="note" :header="$t('operativePlan.notes')"></Column>
                </DataTable>
            </div>
        </div>
    </main>
</template>

<style>

    .p-datatable .p-datatable-tbody > tr.red-row {
        background: orange !important;
    }

    .p-datatable .p-datatable-tbody > tr.yellow-row {
        background: yellow !important;
    }

    .light td[rowspan] {
        background: #f8f9fa !important;
    }

    .dark td[rowspan] {
        background: #1E1E1E !important;
        color: #f8f9fa !important;
    }

    .dark td{
        color: #1E1E1E !important;
    }

    .scrollable {
        overflow-y: auto;
        height: 50vh;
    }

</style>